import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Backdrop,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { Logout } from "@mui/icons-material";

import api, { baseURL } from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardPageNumber,
  setFilesPartsEmpty,
} from "../slice/searchPaginationSlice";
import axios from "axios";

const ReportLists = () => {
  const navigate = useNavigate();
  const { schoolId } = useParams();
  console.log(schoolId, "schoolId");
  const location = useLocation();
  const { agencyName } = location?.state || "";
  const [loading, setLoading] = useState(true);
  const [fileUploadLoading] = useState(false);
  const [dashboardList, setDashboardList] = useState([]);
  const [count, setCount] = useState(0);

  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false);

  const [rowsPerPage] = useState(50);

  const { dashboardPageNumber, dashboardSearchValue, fileType } = useSelector(
    (store) => store.searchPagination
  );
  const [paymentType, setPayment] = useState("Pending");
  const handleDropdownChange = (event) => {
    const { value } = event.target;
    setPayment(value);
  };

  const dispatch = useDispatch();
  const [schoolCode, setSchoolCode] = useState(schoolId);
  useEffect(() => {
    dashboardData();
  }, [paymentType]);
  // let handler;

  // useEffect(() => {
  //   return () => {
  //     clearTimeout(handler);
  //   };
  // }, []);

  // const [page, setPage] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [debouncedQuery, setDebouncedQuery] = useState("");

  const userInfo = getLocalStorage("user")
    ? JSON.parse(getLocalStorage("user"))
    : null;

  const dashboardData = async () => {
    try {
      setDownloadCSVLoading(true);
      //   let apiPath = `compartment/data/?search=${
      //     search || searchQuery
      //   }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;

      // let apiPath = `compartment/form-data?limit=10&offset=0`;
      let apiPath = `payment/status?schoolCode=${
        schoolCode && schoolCode != 0 ? schoolCode : schoolId
      }&status=${paymentType}`;
      // let apiPendingPath = `payment/status?schoolCode=${schoolId}&status=Pending`;

      const response = await api.get(
        schoolCode && schoolCode != 0
          ? apiPath
          : schoolId == 0
          ? `payment/status?status=${paymentType}`
          : apiPath
      );
      // const response1 = await api.get(
      //   schoolId == 0 ? `payment/status?status=Pending` : apiPendingPath
      // );
      // console.log(response, "response");
      setDashboardList([...response?.data?.data]);
      setCount(response?.data?.data?.count);
      // setDashboardList([
      //   {
      //     Compartment_data: {
      //       roll_no: "1234567890",
      //       bseb_unique_id: "1234567890",
      //     },
      //     total_number_records: 10,
      //     status: "pending",
      //     id: 1,
      //   },
      //   {
      //     Compartment_data: {
      //       roll_no: "1234567890",
      //       bseb_unique_id: "1234567890",
      //     },
      //     total_number_records: 10,
      //     status: "success",
      //     id: 1,
      //   },
      //   {
      //     Compartment_data: {
      //       roll_no: "1234567890",
      //       bseb_unique_id: "1234567890",
      //     },
      //     total_number_records: 10,
      //     status: "failed",
      //     id: 1,
      //   },
      // ]);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setLoading(false);
      setDownloadCSVLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setDashboardPageNumber(newPage));
  };

  const getStatusChip = (status) => {
    switch (status) {
      case "Pending":
        return <Chip label="Pending" color="warning" />;
      case "Paid":
        return <Chip label="Success" color="success" />;
      case "Failed":
        return <Chip label="Failed" color="error" />;
      default:
        return <Chip label="Unknown" />;
    }
  };

  const formatCustomDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} ${time}`;
  };

  const handleRowClick = (item) => {
    // navigate(`/student-details/${item?.id}`, {
    //   state: {
    //     details: item,
    //   },
    // });
    navigate(`/report-view/${item?.id}`, {
      state: {
        details: item,
      },
    });
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };

  const handleVerifyAPi = async (trdId, clinetTxnId) => {
    // setLoading(true);
    let newclientTxdId = null;
    try {
      if (!clinetTxnId) {
        newclientTxdId = await handleVerifyAPiForPending(trdId, clinetTxnId);
      }
      if (!newclientTxdId) {
        // toast.dismiss();
        // toast.error("Payment was not successfull");
        return;
      }
      console.log(newclientTxdId, "newclientTxdId");
      const response = await api.post("/payment/verify-payment", {
        transactionId: trdId,
        clientTxnId: clinetTxnId ? clinetTxnId : newclientTxdId,

        // transactionId: clinetTxnId ? clinetTxnId : newclientTxdId,
        // clientTxnId: trdId,

        // "schoolCode": "SPS_123",
        // "compartment_ids": [27,28,29,30,31]
      });
      console.log(response, "response");
      if (response?.data?.success) {
        // navigate("/payment-gateway");
        // const btn = document.getElementById("renderSabPaisa");
        // btn.click();
        // setIsOpen(true);
        toast.dismiss();
        toast.success(response?.data?.message);

        dashboardData();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(
        error?.response?.data?.message ??
          "Some thing went wrong in Verifying, please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyAPiForPending = async (trdId, clinetTxnId) => {
    setLoading(true);

    try {
      const response = await api.post("payment/verify-payment-status", {
        transactionId: clinetTxnId ? clinetTxnId : trdId,
        clientTxnId: trdId,
      });
      console.log(response, "response");

      if (response?.data?.data?.status === "SUCCESS") {
        return response?.data?.data?.sabpaisaTxnId;
      } else {
        toast.dismiss();
        toast.error(response?.data?.data?.status);
      }
    } catch (error) {
    } finally {
    }
  };
  // };
  //console.log(selectBox, "selectBox");
  // if (loading) {
  //   return (
  //     <Box
  //       display="flex"
  //       justifyContent="center"
  //       alignItems="center"
  //       height="100vh"
  //     >
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  const handleRunChromeZome = async () => {
    try {
      setLoading(true);
      //   let apiPath = `compartment/data/?search=${
      //     search || searchQuery
      //   }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;

      // let apiPath = `compartment/form-data?limit=10&offset=0`;
      let apiPath = `payment/update-payment-status?status=${
        paymentType === "Pending" ? "Pending" : "Failed"
      }`;

      const response = await api.get(apiPath);
      if (response?.data?.success) {
        dashboardData();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ??
          "Error Refreshing data. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {/* Image Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {fileUploadLoading ? (
          <Backdrop
            open={fileUploadLoading}
            style={{ zIndex: 9999, color: "#fff" }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : null}

        <Box
          // display="flex"
          // flexWrap="wrap"
          gap="10px"
          // justifyContent="space-between"
          alignItems="center"
          // flexDirection="row"
          mb={3}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{ marginBottom: "10px", width: "91%" }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              }}
            >
              {userInfo?.employeeName} {""}
              {agencyName} Students Report
            </Typography>
            <Box
              style={{
                width: "650px",
                // backgroundColor: "red",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <TextField
                label="school Code"
                name="schoolCode"
                type="text"
                variant="outlined"
                size="small"
                value={schoolCode}
                onChange={(e) => setSchoolCode(e?.target?.value)}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  dashboardData(schoolCode);
                }}
                style={{ textTransform: "none" }}
                disabled={
                  schoolCode?.length === 5 || schoolCode?.length === 0
                    ? false
                    : true
                }
              >
                Search
              </Button>
              <FormControl size="small" variant="outlined">
                <InputLabel>Payment Type</InputLabel>
                <Select
                  label="Payment Type"
                  name="PaymentType"
                  value={paymentType}
                  onChange={handleDropdownChange}
                >
                  <MenuItem key={"Paid"} value={"Paid"}>
                    Success
                  </MenuItem>
                  <MenuItem key={"Pending"} value={"Pending"}>
                    Pending
                  </MenuItem>
                  <MenuItem key={"Failed"} value={"Failed"}>
                    Failed
                  </MenuItem>

                  {/**<MenuItem key={"Agency1"} value={"Agency1"}>
                  Agency 1
                </MenuItem>
                <MenuItem key={"Agency2"} value={"Agency2"}>
                  Agency 2
                </MenuItem> */}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                onClick={handleRunChromeZome}
                style={{ textTransform: "none" }}
              >
                Refresh All Transactions
              </Button>
            </Box>
          </Box>
          <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
            {/* <TextField
              id="standard-basic"
              label="Search..."
              variant="outlined"
              // onChange={(e) => setSearchQuery(e.target.value)}
              onChange={(e) => handleSearch(e.target.value)}
              value={searchQuery}
              size="small"
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        handleSearch("");
                      }}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            /> */}
            {/* <Button
              variant="contained"
              color="primary"
              onClick={searchRecord}
              style={{
                textTransform: "none",
                backgroundColor: "#8C0001",
              }}
            >
              Search
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/dashboard");

                dispatch(setFilesPartsEmpty());
              }}
              style={{ textTransform: "none" }}
            >
              Back to Dashboard
            </Button>

            {/* {selectedRows?.length > 1 && (
              // <Button
              //   variant="text"
              //   color="primary"
              //   style={{
              //     textTransform: "none",
              //     color: "#8C0001",
              //     borderColor: "#8C0001",
              //   }}
              //   startIcon={<Download />}
              //   onClick={handleMultiDownLoad}
              // >
              //   Download Files
              // </Button>

              <Button
                onClick={handleMultiDownLoad}
                variant="outlined"
                // disabled={true}
                startIcon={<Download />}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Download Consolidated Files
              </Button>
            )} */}

            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none", marginLeft: "auto" }}
            >
              Logout
            </Button>
          </Box>
        </Box>

        {/* <AppBar
          position="static"
          sx={{ backgroundColor: "white", boxShadow: "none" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {agencies.map((agency, index) => (
              <Tab
                key={index}
                label={agency}
                sx={{
                  fontSize: "10px",
                }}
              />
            ))}
          </Tabs>
        </AppBar> */}

        <TableContainer
          // sx={{ maxHeight: "58vh", overflow: "auto" }}
          component={Paper}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow style={{ textWrap: "nowrap", textAlign: "center" }}>
                <TableCell align="left">
                  <strong>Time</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Transaction ID</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>School Code</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Amount</strong>
                </TableCell>
                {/* <TableCell align="center">
                  <strong>Total Edited Records</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Total Approval Records</strong>
                </TableCell> */}
                <TableCell align="center">
                  <strong>Payment Status</strong>
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    background: "white", // Ensures it stays visible
                    zIndex: 2, // Ensures it stays above other columns
                  }}
                >
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardList?.length > 0 ? (
                dashboardList?.map((row) => (
                  <TableRow
                    key={row?.id}
                    style={{ textWrap: "nowrap", textAlign: "center" }}
                  >
                    <TableCell style={{ textAlign: "left" }}>
                      <div>
                        <span>
                          {row?.createdAt
                            ? new Date(row?.createdAt).toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                              })
                            : "-"}
                        </span>
                      </div>
                    </TableCell>

                    <TableCell align="center">
                      {row?.transactionId ? row?.transactionId : "_"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.schoolCode ? row?.schoolCode : "_"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.amount ? row?.amount : 0}
                    </TableCell>

                    <TableCell
                      align="center"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {row?.transactionStatus
                        ? getStatusChip(row.transactionStatus)
                        : "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        right: 0,
                        marginTop: "6px",

                        background: "white", // Ensures it stays visible
                        zIndex: 1, // Ensures it stays above other columns
                      }}
                      // style={{
                      //   display: "flex",
                      //   gap: "10px",
                      //   justifyContent: "center",
                      // }}
                    >
                      <Button
                        variant="contained"
                        style={{
                          textTransform: "none",
                          backgroundColor: "#8C0001",
                        }}
                        size="small"
                        onClick={() => handleRowClick(row)}
                      >
                        View Report
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() =>
                          // handleVerifyAPi(
                          //   row?.transactionId,
                          //   row?.clientTxnId
                          // )
                          handleVerifyAPi(row?.transactionId)
                        }
                        style={{ textTransform: "none", marginLeft: "3px" }}
                      >
                        Refresh
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          // rowsPerPageOptions={[5, 10, 25, 30]}
          rowsPerPageOptions={undefined}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={dashboardPageNumber}
          onPageChange={handleChangePage}

          // onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </Container>

      {/* Loader Backdrop */}
      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ReportLists;
